import type { UserSchema } from '@shape-construction/api/src-global/types';
import { useSession } from './session';

/**
 * Get the current user from session context.
 * If there is no user present, throws error.
 */
export const useCurrentUser = (): UserSchema => {
  const { user } = useSession();
  if (!user) throw new Error('useCurrentUser: Cannot get current user');
  return user;
};
